import React, { useEffect, useState } from 'react';
import Button from '../../../../ui-core/Button/Button';
import { grecaptcha } from '../../../../services/recaptcha';
import { getItem, removeItem, setItem } from '../../../../utils/cache';
// import { extractJSON } from '../../../../services/jsonUtil';
import { MODAL_TYPE } from '../../../../constants/app';
import PropTypes from 'prop-types';
import './../../../../ui-core/Modal/style.css';
import { useModal } from '../../../../context/ModalContext';
import { useDispatch, useSelector } from 'react-redux';
// import { doUpdateUserProfieRequest } from '../../../../store/action/user';
import {
  doSendMergeOtpRequest,
  // doUpdateWithOtpRequest,
} from '../../../../store/action/auth';
import { getUserAttribute } from '../../../../utils/helpers';
import { trackDisplayedEvent } from '../../../../utils/Segment';

const ConfirmPhoneModal =
  (/* { show, handleClose, dialogClassName = "", setIsMergeModalOpen, postData, handleSubmit, } */) => {
    const { isLoading } = useSelector(state => state.user);
    // const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
    // const [isLoading /* setIsLoading */] = useState(false);
    const urlParams = new URLSearchParams(window.location.search);
    // const uid = urlParams.get('uid');
    const provider = urlParams.get('provider');
    const isAppleLogin = getItem('isAppleLogin');
    const { closeModal, handleGlobalModalState } = useModal();
    const dispatch = useDispatch();
    const mergePhoneDetails = JSON.parse(getItem('mergePhoneDetail'));
    const [postData, setPostData] = useState({
      mobile: mergePhoneDetails?.mobile || null,
      country_code: mergePhoneDetails?.country_code || null,
    });
    // const social_token = urlParams.get('access_token');

    useEffect(() => {
      if (mergePhoneDetails) {
        setPostData({
          mobile: mergePhoneDetails?.mobile || null,
          country_code: mergePhoneDetails?.country_code || null,
        });
      } else {
        setPostData({
          mobile: getUserAttribute('mobile') || null,
          country_code: getUserAttribute('country_code') || null,
        });
      }
    }, []);

    const handleCancel = () => {
      removeItem('AccountMerge');
      closeModal();
    };

    const handleSubmit = () => {
      setItem('AccountMerge', true);
      grecaptcha.execute(token => {
        // trackSubmittedEvent('Sign up submit', {
        //   page: 'Home Page',
        //   section_title: 'Signup Modal',
        //   button_title: 'SEND VERIFICATION CODE',
        //   phone: postData?.mobile,
        //   country_code: postData?.country_code,
        // });
        if (provider || isAppleLogin) {
          localStorage?.setItem('SocialLoginData', JSON.stringify(postData));
          // const session = extractJSON(LOCAL_STORAGE_CONSTANT.SESSION);
          // const data = {
          //   ...postData,
          //   name: '',
          //   // email: uid || session?.uid,
          //   email: user?.attributes?.email || uid || session?.uid,
          //   token: social_token || session?.access_token,
          //   user_profile_attributes: {
          //     goal: '',
          //     tried_solutions: '',
          //     exercise_frequency: '',
          //     time_per_day: '',
          //     preferred_part_of_day: '',
          //   },
          // };
          dispatch(
            doSendMergeOtpRequest({
              data: {
                type: 'mobile',
                ...postData,
              },
              callback: () => {
                handleGlobalModalState(MODAL_TYPE.OTP);
                // dispatch(
                //   doUpdateUserProfieRequest({
                //     data,
                //     callback: () => {
                //       handleGlobalModalState(MODAL_TYPE.OTP);
                //     },
                //   }),
                // );
              },
            }),
          );
        } else {
          // dispatch(
          //   doSignupRequest({
          //     data: {
          //       ...postData,
          //       email: SignUpData?.email,
          //       password: SignUpData?.password,
          //       email_signup: true,
          //       type: 'signup',
          //       token,
          //     },
          //     callback: () => handleModalState(MODAL_TYPE.OTP),
          //     page: props.page,
          //   }),
          // );

          // dispatch(
          // doUpdateWithOtpRequest({
          //         data: {
          //             ...postData,
          //         },
          //         callback: () => handleModalState(MODAL_TYPE.OTP),
          //         page: 'Home Page',
          //     }),
          // );
          dispatch(
            doSendMergeOtpRequest({
              data: {
                type: 'mobile',
                ...postData,
              },
              callback: () => {
                handleGlobalModalState(MODAL_TYPE.OTP);
              },
            }),
          );
        }

        trackDisplayedEvent('Display OTP Modal', {
          page: 'Home Page',
          section_title: 'OTP Modal',
        });
      });
    };

    return (
      <div className="form-h">
        <h2 className="sign-in-h1">Confirm Phone Number</h2>
        <p className="sign-in-h3 mb-4 mt-4 pb-3">
          An account with this phone number already exists. Please confirm your
          phone number to sync it with this account.
        </p>

        <div className="row">
          <div className="col-6">
            <Button
              text="NOT NOW"
              // TODO: we need to add 'spinner-border text-white'
              class={`OtpButton-outline m-0 ${isLoading && ''}`}
              isDisabled={isLoading}
              isLoading={isLoading}
              onClick={handleCancel}
            />
          </div>
          <div className="col-6">
            <Button
              text="CONTINUE"
              // TODO: we need to add 'spinner-border text-white'
              class={`OtpButton m-0 ${isLoading && ''}`}
              isDisabled={isLoading}
              isLoading={isLoading}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  };

ConfirmPhoneModal.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  dialogClassName: PropTypes.string,
  setIsMergeModalOpen: PropTypes.func,
  postData: PropTypes.object,
  handleSubmit: PropTypes.func,
};

export default ConfirmPhoneModal;
